export default __webpack_public_path__ + "static/media/AboutUsPage.c9232ae2.jpeg";